<div class="chat-avatar" [ngStyle]="{backgroundImage: 'url(' + imageUrl + ')'}"></div>
